import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '../../../components/Flex';
import { Form } from 'antd';
import { Button, Input, useTheme } from '@prio365/prio365-react-library';
import { colon } from '../../../util/forms';
import { PrioTheme } from '../../../theme/types';
import { getSvgIconPathByType } from '../../../util/icon';
import SvgIcon from '../../../components/SvgIcon';
import { JiraConfiguration } from '../../../models/ProjectExtension';
import { makePrioStyles } from '../../../theme/utils';
import { Setting } from '../../../models/Settings';
import { apiDeleteSetting } from '../api';

const DEFAULT_PW = '*******';

const useStyles = makePrioStyles((theme: PrioTheme) => ({
  rootLayout: {
    margin: 0,
  },
  editContent: {
    backgroundColor: theme.colors.application.background.default,
  },
  form: {
    height: '100%',
    width: '100%',
    overflow: 'auto',
  },
  fullWidth: {
    width: '100%',
  },
  danger: {
    color: theme.old.palette.chromaticPalette.red,
    '&:hover': {
      backgroundColor: theme.old.palette.chromaticPalette.red,
      color: theme.old.palette.chromaticPalette.white + ' !important',
    },
  },
}));

interface AddInItemConfigProps {
  className?: string;
  projectExtensionConfigurationChanged: () => void;
  jiraSetting: Setting;
  onClose: VoidFunction;
}

export const JiraConfigurationForm: React.FC<AddInItemConfigProps> = (
  props
) => {
  //#region ------------------------------ Defaults
  const { projectExtensionConfigurationChanged, onClose, jiraSetting } = props;
  const { t } = useTranslation();
  const theme = useTheme<PrioTheme>();
  const classes = useStyles();
  const [dataForm] = Form.useForm<JiraConfiguration>();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const handleFinish = () => {
    onClose();
  };

  const handleDelete = async () => {
    await apiDeleteSetting(jiraSetting[0].settingId);
    projectExtensionConfigurationChanged();
    onClose();
  };
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <div style={{ display: 'flex', flex: 1, width: '100%' }}>
        <Form
          layout="vertical"
          form={dataForm}
          className={classes.form}
          onFinish={handleFinish}
        >
          <Flex.Row>
            <SvgIcon
              width={42}
              height={42}
              path={getSvgIconPathByType('jira')}
            ></SvgIcon>
            <h3 style={{ marginTop: '6px', marginBottom: '32px' }}>
              Jira {t('settings:jiraConfig.connection')}
            </h3>
          </Flex.Row>
          <Flex.Row flex={1}>
            <Flex.Column childrenGap={theme.spacing.small} flex={1}>
              <Flex.Row
                childrenGap={theme.spacing.small}
                justifyContent="stretch"
              >
                <Form.Item
                  name={['objectJson', 'baseURL']}
                  label={t('projects:addIn.jiraConfig.jiraUrl')}
                  colon={colon}
                  style={{ flex: 1 }}
                >
                  <Input disabled={true} full defaultValue={DEFAULT_PW} />
                </Form.Item>
              </Flex.Row>
              <Flex.Row
                childrenGap={theme.spacing.small}
                justifyContent="stretch"
              >
                <Form.Item
                  name={['objectJson', 'serviceUserCredentials', 'mail']}
                  label={t('projects:addIn.jiraConfig.mail')}
                  colon={colon}
                  style={{ flex: 1 }}
                >
                  <Input disabled={true} full defaultValue={DEFAULT_PW} />
                </Form.Item>
                <Form.Item
                  name={['objectJson', 'serviceUserCredentials', 'apiKey']}
                  label={t('projects:addIn.jiraConfig.apiToken')}
                  colon={colon}
                  style={{ flex: 1 }}
                >
                  <Input
                    disabled={true}
                    type="password"
                    full
                    defaultValue={DEFAULT_PW}
                  />
                </Form.Item>
                <Form.Item
                  name={'rowVersion'}
                  hidden={true}
                  colon={colon}
                  style={{ flex: 1 }}
                ></Form.Item>
              </Flex.Row>
            </Flex.Column>
          </Flex.Row>
        </Form>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button type="danger" onClick={handleDelete}>
          {t('projects:addIn.jiraConfig.delete')}
        </Button>
      </div>
    </div>
  );
};

export default JiraConfigurationForm;
